import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Table, Icon } from "semantic-ui-react";
import _ from "lodash";
import cx from "classnames";

import { fetchGeneratedReport } from "actions/generateReport";
import InfiniteScroll from "components/ui/InfiniteScroll";

import styles from "./reports.module.scss";

const Reports = ({ account, setLoading, filters }) => {
  const dispatch = useDispatch();

  const reports = useSelector((state) => _.get(state, "generateReports.items", []));
  const loading = useSelector((state) => _.get(state, "generateReports.loading", false));
  const currentPage = useSelector((state) =>
    _.get(state, "generateReports.pagination.currentPage", 0)
  );
  const totalPages = useSelector((state) =>
    _.get(state, "generateReports.pagination.totalPages", 1)
  );

  const [page, setPage] = useState(0);

  useEffect(() => {
    setPage(0);
  }, [filters]);


  useEffect(() => {
    console.log("Updated Reports:", reports);
  }, [reports]);

  useEffect(() => {
    setLoading(loading);
  }, [loading, setLoading]);

  useEffect(() => {
    if (account && account.id) {
      dispatch(
        fetchGeneratedReport({
          page,
          limit: 10,
          filters: { ...filters, accountId: account?.id },
        })
      );
    }
  }, [account, filters, page]);

  const getStatusColor = (status) => {
    switch (status) {
      case "COMPLETED":
        return "#21c339";
      case "IN_PROGRESS":
        return "#FE9D44";
      case "ERROR":
        return "#e51058";
      case "STARTED":
        return "#0066ff";
      default:
        return "gray";
    }
  };

  const renderTableBody = () => {
    if (loading && page === 0) {
      return (
        <Table.Row>
          <Table.Cell colSpan="6" className={cx(styles.cell)}>
            <div className={cx(styles.loader)}>
              <Icon name="sync" loading className={cx(styles.icon)} />
              Loading...
            </div>
          </Table.Cell>
        </Table.Row>
      );
    }

    if (!loading && _.size(reports) === 0) {
      return (
        <Table.Row>
          <Table.Cell colSpan="6" className={cx(styles.cell)}>
            <div className={cx(styles.noData)}>No Data</div>
          </Table.Cell>
        </Table.Row>
      );
    }

    return reports.map((item, idx) => (
      <Table.Row key={idx}>
        <Table.Cell width={4} className={cx(styles.cellFrist)}>
          <div className={cx(styles.text)}>{item.toEmail || "N/A"}</div>
        </Table.Cell>
        <Table.Cell
          width={2}
          className={cx(styles.cell)}
          style={{ color: getStatusColor(item.status) }}
        >
          <div>{item.status || "N/A"}</div>
        </Table.Cell>
        <Table.Cell width={2} className={cx(styles.cell)}>
          <div className={cx(styles.text)}>
            {item.fromDate ? new Date(item.fromDate).toLocaleDateString() : "N/A"}
          </div>
        </Table.Cell>
        <Table.Cell width={2} className={cx(styles.cell)}>
          <div className={cx(styles.text)}>
            {item.toDate ? new Date(item.toDate).toLocaleDateString() : "N/A"}
          </div>
        </Table.Cell>
        <Table.Cell width={4} className={cx(styles.cell)}>
          <div className={cx(styles.text)}>{item.type || "N/A"}</div>
        </Table.Cell>
        <Table.Cell width={2} className={cx(styles.cell)}>
          <div className={cx(styles.text)}>
            {item.createdDate
              ? new Date(item.createdDate).toLocaleDateString()
              : "N/A"}
          </div>
        </Table.Cell>
      </Table.Row>
    ));
  };

  return (
    <InfiniteScroll
      loading={loading}
      currentPage={currentPage}
      totalPages={totalPages}
      pagination={true}
      setPage={setPage}
    >
      <Table singleLine className={cx(styles.table)}>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell width={4} className={cx(styles.header)}>TO EMAIL</Table.HeaderCell>
            <Table.HeaderCell width={2} className={cx(styles.header)}>STATUS</Table.HeaderCell>
            <Table.HeaderCell width={2} className={cx(styles.header)}>FROM</Table.HeaderCell>
            <Table.HeaderCell width={2} className={cx(styles.header)}>TO</Table.HeaderCell>
            <Table.HeaderCell width={4} className={cx(styles.header)}>TYPE</Table.HeaderCell>
            <Table.HeaderCell width={2} className={cx(styles.header)}>CREATED DATE</Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body className={cx(styles.body)}>{renderTableBody()}</Table.Body>
      </Table>
    </InfiniteScroll>

  );
};

export default Reports;